<template>
  <div class="aside">
    <div class="user">
      <img :src="ang1" class="ang1" />
      <img :src="ang2" class="ang2" />
      <img :src="ang3" class="ang3" />
      <img :src="ang4" class="ang4" />
      <div class="userTop">
        <div class="userIcon" @click="showPersonalInfoDialog">
          <img class="userPhoto" :src="userPhoto" />
          <img class="editIcon" src="@/assets/images/list/edit.png" alt="" />"
        </div>
        <div>
          <div class="name">{{ name }}</div>
          <div class="status">
            <div
              class="leave"
              @click="changeLeaveState"
              :class="{
                selected: !$store.state.user.ready,
                disab: isInRoom || !$store.state.user.ready
              }"
            >
              <img :src="$store.state.user.ready ? leave2 : leave1" />
              <span>离岗</span>
            </div>
            <div
              class="ready"
              @click="changeReadyState"
              :class="{
                selected: $store.state.user.ready,
                disab: isInRoom || $store.state.user.ready
              }"
            >
              <img :src="$store.state.user.ready ? ready1 : ready2" />
              <span>就绪</span>
            </div>
          </div>
        </div>
      </div>
<!--      <div class="userBot">-->
<!--        <div class="title">-->
<!--          <span class="icon"></span>-->
<!--          <span class="name">接警房间</span>-->
<!--        </div>-->
<!--        <ul class="content" v-if="currentRoomInfo && currentRoomInfo.length">-->
<!--          <li-->
<!--            v-for="{ accidentId, phone } in currentRoomInfo"-->
<!--            :key="accidentId"-->
<!--          >-->
<!--            <div>-->
<!--              <img :src="phonIcon" class="phonIcon" />-->
<!--              <span style="color: #0ebd35; font-size: 16px; margin-left: 5px"-->
<!--                >报警电话</span-->
<!--              >-->
<!--              <div style="color: #0ebd35; font-size: 18px">-->
<!--                {{ formatPhone(phone) }}-->
<!--              </div>-->
<!--            </div>-->
<!--            <img :src="enterRoom" class="enterRoom" />-->
<!--          </li>-->
<!--        </ul>-->
<!--        <div v-else class="noData">-->
<!--          <img :src="noData" />-->
<!--          <div>没有可返回的通话</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="phonData">
      <img :src="ang1" class="ang1" />
      <img :src="ang2" class="ang2" />
      <img :src="ang3" class="ang3" />
      <img :src="ang4" class="ang4" />
      <div class="timeFilter">
        <el-date-picker
          v-model="timeRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="handleTimeChange"
        />
      </div>
      <div class="dataList">
        <ul>
          <li v-for="(item, index) in phonData" :key="index">
            <div class="dataImg">
              <img :src="item.icon" />
            </div>
            <div class="dataMsg">
              <div class="dataNum">{{ item.num }}</div>
              <div class="dataName">{{ item.name }}</div>
            </div>
          </li>
          <li :class="phonData.length % 2 ? 'dataTitle' : 'dataTitle2'">
            数据统计
          </li>
        </ul>
      </div>
    </div>
    <myDialog
      :logTitle="'个人信息'"
      :logHeight="'400px'"
      :showDialog.sync="personalInfoVisible"
    >
      <div class="userInfoLog">
        <el-form
          ref="form"
          :model="personalInfo"
          size="small"
          inline
          label-position="left"
          label-width="80px"
        >
          <el-form-item label="用户账号" prop="username">
            <el-input
              v-model="personalInfo.username"
              placeholder="请输入用户账号"
            />
          </el-form-item>
          <el-form-item label="用户姓名" prop="name">
            <el-input
              v-model="personalInfo.name"
              placeholder="请输入用户姓名"
            />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              v-model="personalInfo.password"
              placeholder="请输入密码"
            />
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input
              type="password"
              v-model="personalInfo.confirmPassword"
              placeholder="请重新输入密码"
            />
          </el-form-item>
          <el-form-item label="备注" prop="remark" style="width:100%">
            <el-input
              v-model="personalInfo.remark"
              placeholder="请输入备注"
              :rows="2"
              type="textarea"
            />
          </el-form-item>
        </el-form>
        <div class="dialog-footer">
          <span class="partyBtn btn1" @click="personalInfoVisible = false">
            取 消
          </span>
          <span class="partyBtn btn2" @click="savePersonalInfo"> 确 定 </span>
        </div>
      </div>
    </myDialog>
  </div>
</template>

<script>
import { api } from "@/plugins/api";
import { mapGetters } from "vuex";
import { Mutations } from "@/store/mutations";
import { getAccidentRoom, reEnterAccidentRoom, exitAccidentRoom } from "@/api";
import videoCall from "@/phoneVideo/video-call";
import { getVideoTimeBy5G } from "@/api/accident/edit.js";
import myDialog from "@/components/custom/myDialog.vue";
export default {
  components: { myDialog },
  props: {
    dataType: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ang1: require("@/assets/images/list/ang1.png"),
      ang2: require("@/assets/images/list/ang2.png"),
      ang3: require("@/assets/images/list/ang3.png"),
      ang4: require("@/assets/images/list/ang4.png"),
      userPhoto: require("@/assets/images/list/userPhoto.png"),
      leave1: require("@/assets/images/list/leave1.png"),
      leave2: require("@/assets/images/list/leave2.png"),
      ready1: require("@/assets/images/list/ready1.png"),
      ready2: require("@/assets/images/list/ready2.png"),
      phonIcon: require("@/assets/images/list/phone.png"),
      enterRoom: require("@/assets/images/list/enterRoom.png"),
      noData: require("@/assets/images/list/noData.png"),
      currentRoomInfo: [],
      phonData: [],
      timeRange: [],
      personalInfoVisible: false,
      saveLoading: false,
      personalInfo: {
        username: "",
        name: "",
        password: "",
        confirmPassword: "",
        remark: ""
      }
    };
  },
  computed: {
    ...mapGetters(["name", "visitedViews"]),
    isInRoom() {
      return !!~this.visitedViews.findIndex(
        ({ name }) => name === "AccidentAdd"
      );
    },
    sysUser() {
      return this.$store.state.user.sysUser;
    },
    accidentId() {
      return this.$route.params.id;
    }
  },
  created() {
    const exitId = sessionStorage.getItem("exitId");
    const userName = this.$store.state.user.username;
    if (localStorage.getItem('isReady') === '1') {
      console.log('重置重登');
      this.changeReadyState()
    }
    if (exitId) {
      this.exitRoom(exitId, userName);
    }
    this.fetchStatisticsData();
  },
  methods: {
    fetchStatisticsData() {
      const params = {
        loginType: localStorage.getItem("loginType")
      };
      if (this.timeRange && this.timeRange.length === 2) {
        params.startTime = this.timeRange[0];
        params.endTime = this.timeRange[1];
      }
      api.workstation.data.getData
        .r(params)
        .then(data => {
          this.phonData = [];
          if (data && Object.keys(data).length) {
            this.dataType.forEach(el => {
              Object.keys(data).forEach(name => {
                let obj = {};
                if (el.name === name) {
                  obj.name = el[name];
                  obj.icon = el.icon;
                  obj.num = data[name];
                  this.phonData.push(obj);
                }
              });
            });
          }
        });
    },

    handleTimeChange() {
      this.fetchStatisticsData();
    },
    changeReadyState() {
      localStorage.setItem("isReady", "1");
      api.video.trtc.ready.r().then(res => {
        if (res && res.code === "200") {
          this.$store.commit(Mutations.CHANGE_READY_STATE); // 修改就绪样式
          console.log("5g视频");

          const { extension, extensionCode } = this.sysUser;
          // var aa = extension + 1
          console.log(111, extension);
          if (extension) {
            videoCall.login(
              //拨打 1000, 888@119.91.76.81:9060
             extension.toString(),
              // '1004',
              "aegis2020",
              // "aegis1234", // 测试环境
              // '1002',
              // extensionCode,
              data => {
                console.log("来5g电话了", data);
                if (localStorage.getItem('isReady')==='1') {
                  this.$store.commit("app/SET_VIDEODATA", { type: 1, phone: data });
                }
              },
              () => {
                console.log("分机登陆成功");
              },
              data => {
                console.log("用户挂断", data);
                getVideoTimeBy5G({
                  accidentId: this.accidentId,
                  type: 1,
                  time: new Date().getTime()
                }).then(() => {
                  console.log("挂断了");
                  this.$store.commit("app/SET_ISHANGUP", true);
                });
              }
            );
          }

        }
      });
    },
    changeLeaveState() {
      if (this.isInRoom || !this.$store.state.user.ready) {
        return;
      }
      api.video.trtc.leave.r().then(res => {
        if (res && res.code === "200") {
          const { extension } = this.sysUser;
          if (extension) {
            videoCall.logout(msg => {
              console.log("分机登出：" + msg);
            });
          }
          this.$store.commit(Mutations.CHANGE_LEAVE_STATE); // 修改离岗样式
        }
      });
      localStorage.setItem("isReady", "0");
    },
    async savePersonalInfo() {
      if (this.personalInfo.password) {
        if (!this.personalInfo.confirmPassword) {
          this.$message.error("请填写确认密码");
          return;
        }
        if (this.personalInfo.password !== this.personalInfo.confirmPassword) {
          this.$message.error("两次密码输入不一致");
          return;
        }
      }

      try {
        this.saveLoading = true;
        await this.$api.system.user.modifyPersonalInfo.r(this.personalInfo);
        this.personalInfoVisible = false;
        this.logout();
      } catch (e) {
      } finally {
        this.saveLoading = false;
      }
    },
    showPersonalInfoDialog() {
      console.log(6666);
      this.personalInfo.name = this.$store.state.user.name;
      this.personalInfo.username = this.$store.state.user.username;
      this.personalInfo.remark = this.$store.state.user.sysUser.remark;
      this.personalInfoVisible = true;
    },
    formatPhone(phoneNumber) {
      return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    },
    getAccidentRoom() {
      getAccidentRoom().then(({ data = [] }) => {
        this.currentRoomInfo = data;
      });
    },
    backRoom(accidentId) {
      reEnterAccidentRoom(accidentId);
      this.$store.commit(Mutations.CHANGE_LEAVE_STATE);
      localStorage.setItem("isReady", "0");
      router.push({ name: "AccidentAdd", params: { id: accidentId } });
    },
    exitRoom(accidentId, agentUserName) {
      exitAccidentRoom(accidentId, agentUserName)
        .then(res => {
          this.currentRoomInfo.splice(
            this.currentRoomInfo.findIndex(
              ({ accidentId: findId }) => findId === accidentId
            ),
            1
          );
          api.video.trtc.ready.r().then(res => {
            if (res.code === "200") {
              this.$store.commit(Mutations.CHANGE_READY_STATE);
              localStorage.setItem("isReady", "1");
            }
          }); // 就绪请求
          sessionStorage.setItem("exitId", "");
        })
        .catch(err => {
          console.log("未退出通话：" + err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "customFont"; //重命名字体名
  src: url("./font/customFont.ttf"); //引入字体
  font-weight: normal;
  font-style: normal;
}
.aside {
  padding-bottom: 40px;
  .user {
    position: relative;
    width: 340px;
    height: 378px;
    background: rgba(15, 31, 70, 0.6);
    box-shadow: 0px 0px 12px 0px rgba(0, 159, 255, 0.54);
    border: 1px solid #0278c6;
    margin-bottom: 20px;
    .userTop {
      height: 160px;
      border-bottom: 1px solid #0278c6;
      display: flex;
      margin-bottom: 20px;
      justify-content: space-evenly;
      align-items: center;
      .userIcon {
        width: 80px;
        height: 80px;
        position: relative;
        cursor: pointer;
        .userPhoto {
          width: 80px;
          height: 80px;
        }
        .editIcon {
          width: 30px;
          height: 30px;
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }

      .name {
        font-size: 24px;
        color: #b1e3ff;
        letter-spacing: 1px;
      }
      .status {
        display: -webkit-flex;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 180px;
        height: 36px;
        margin: 10px auto;
        cursor: pointer;
        overflow: hidden;
        border-radius: 36px;
        background: rgba(0, 12, 41, 0.8);
        // box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.5);
        .leave,
        .ready {
          width: 90px;
          height: 100%;
          line-height: 36px;
          color: #b1e3ff;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            margin-left: 5px;
          }
        }
        .ready.selected {
          width: 100px;
          border-radius: 36px;
          color: #fff;
          background-color: #0ebd35;
        }
        .leave.selected {
          width: 100px;
          border-radius: 36px;
          color: #fff;
          background-color: #ff7d00;
        }
        .ready.disab,
        .leave.disab {
          cursor: not-allowed;
        }
      }
    }
    .userBot {
      width: 100%;
      height: 190px;
      .title {
        margin-left: 30px;
        .icon {
          display: inline-block;
          width: 4px;
          height: 16px;
          background: #0084ff;
          border-radius: 2px;
          vertical-align: middle;
        }
        .name {
          display: inline-block;
          margin-left: 10px;
          font-size: 16px;
          color: #0084ff;
          vertical-align: middle;
        }
      }
      .content {
        width: 280px;
        height: 100px;
        padding: 0;
        margin: 0;
        margin: 30px auto;
        overflow: auto;
        li {
          display: -webkit-flex;
          display: flex;
          justify-content: space-between;
          align-items: center;
          list-style: none;
          width: 100%;
          height: 80px;
          margin-bottom: 20px;
          padding: 20px;
          background-color: rgba(14, 189, 53, 0.2);
          box-shadow: 0px 0px 12px 0px #0ebd35;
          border-radius: 4px;
          opacity: 0.8;
          border: 1px solid #0ebd35;
          .phonIcon {
            vertical-align: middle;
          }
          .enterRoom {
            cursor: pointer;
          }
        }
        &::-webkit-scrollbar {
          /*定义滚动条高宽及背景
          高宽分别对应横竖滚动条的尺寸*/
          width: 0px;
          background-color: #f5f5f5;
        }
      }
      .noData {
        width: 280px;
        height: 100px;
        margin: 20px auto 0;
        text-align: center;
        div {
          color: rgba(0, 132, 255, 1);
          font-size: 14px;
        }
      }
    }
  }
  .phonData {
    position: relative;
    width: 340px;
    height: 450px;
    background: rgba(15, 31, 70, 0.6);
    box-shadow: 0px 0px 12px 0px rgba(0, 159, 255, 0.54);
    border: 2px solid #0278c6;
    .timeFilter {
      padding: 15px 20px 0;
      .el-date-editor--daterange {
        width: 100%;
        .el-input__inner {
          background: rgba(0, 132, 255, 0.1);
          border: 1px solid #0084ff;
          color: #b1e3ff;
          height: 36px;
        }
        .el-input__inner:hover {
          border-color: #0084ff;
        }
      }
    }
    .dataList {
      ul {
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        li {
          list-style: none;
          width: 168px;
          height: 102px;
          border-bottom: 1px solid #17ecfe;
          box-shadow: 0px 0px 12px 0px rgba(0, 159, 255, 0.54);
          display: flex;
          align-items: center;
          &:nth-child(even) {
            border-left: 1px solid #17ecfe;
            box-shadow: 0px 0px 12px 0px rgba(0, 159, 255, 0.54);
          }
          .dataImg {
            img {
              margin: 5px 0 0 30px;
            }
          }
          .dataMsg {
            margin-left: 5px;
            .dataNum {
              width: 100%;
              font-family: "customFont";
              font-size: 20px;
              font-weight: bold;
              color: #17ecfe;
            }
            .dataName {
              width: 100%;
              font-size: 13px;
              color: #b1e3ff;
              margin-top: -10px;
            }
          }
        }
        .dataTitle {
          padding: 30px;
          color: rgba(0, 159, 255, 0.54);
          font-size: 22px;
          font-weight: 600;
          letter-spacing: 4px;
          text-align: center;
          line-height: 50px;
        }
        .dataTitle2 {
          width: 338px;
          padding: 30px 115px;
          color: rgba(0, 159, 255, 0.54);
          font-size: 22px;
          font-weight: 600;
          letter-spacing: 4px;
          text-align: center;
          line-height: 50px;
        }
      }
    }
  }
  .ang1 {
    position: absolute;
    top: -3px;
    left: -3px;
  }
  .ang2 {
    position: absolute;
    top: -3px;
    right: -3px;
  }
  .ang3 {
    position: absolute;
    bottom: -3px;
    left: -3px;
  }
  .ang4 {
    position: absolute;
    bottom: -3px;
    right: -3px;
  }
  .userInfoLog {
    // ::v-deep.el-form-item{
    //   margin-left: 10px;
    // }
    ::v-deep.el-form-item__label {
      color: #17ECFE;
      font-size: 14px;
    }
    input,
    .el-input {
      width: 260px;
      height: 40px;
      margin-bottom: 20px;
    }
     ::v-deep.el-input__inner {
       width: 260px;
       height: 40px;
     }
    ::v-deep.el-input__inner,
    ::v-deep.el-textarea__inner {
      background: rgba(0, 132, 255, 0.1);
      border: 1px solid #0084ff;
      color: #b1e3ff;
      &::-webkit-input-placeholder {
        color: #b1e3ff;
      }
      &:hover {
        border: 1px solid #0084ff;
      }
    }
    ::v-deep.el-textarea__inner {
      width: 610px;
      height: 80px;
    }

    .dialog-footer {
      margin-top: 15px;
      text-align: center;
      .partyBtn {
        display: inline-block;
        width: 160px;
        height: 48px;
        line-height: 48px;
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        font-size: 20px;
      }
      .btn1 {
        color: #b1e3ff;
        background: rgba(0, 132, 255, 0.1);
        border: 1px solid #0084ff;
        margin-right: 15px;
      }
      .btn2 {
        color: #0ebd35;
        background: rgba(14, 189, 53, 0.1);
        border: 1px solid #0ebd35;
      }
    }
  }
}
</style>
